import { loadable } from '../../services/loadable';

export default loadable(() =>
  import(/* webpackChunkName: "forum-rce-frameless" */ '../rich-content-editor'),
);
